<template>
    <div class="notification-personal-data">
        <h3 class="notification-personal-data__header">Использование cookies</h3>
        <p class="notification-personal-data__description">
            Для улучшения работы сайт SimpleEstate может собирать файлы cookies,
            в том числе посредством метрической программы «Яндекс метрика».<br/>
            Обработка осуществляется согласно условиям <a v-bind:href="urls.policies.privacyPolicy" target="_blank">политики конфиденциальности</a>.
            Продолжая работу с сайтом, Вы даёте своё <a v-bind:href="urls.policies.consent.cookie" target="_blank">согласие</a> на обработку персональных данных.
        </p>
        <div class="notification-personal-data__buttons">
            <ui-button
                v-on:click="() => select({ consent: 0, date: Date.now() })"
                text="Отклонить"
                theme="secondary"
                size="sm"
            />
            <ui-button
                v-on:click="() => select({ consent: 1, date: Date.now() })"
                text="Принять"
                theme="primary"
                size="sm"
            />
        </div>
    </div>
</template>

<script>
import config from '~/config';

export default {
    name: 'notification-personal-data',
    props: [ 'onSelect', 'index' ],
    data: () => ({
        urls: config.urls,
    }),
    methods: {
        select(choose) {
            this.onSelect(choose, this.index);
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.notification-personal-data {
    .notification();

    &__header {
        .typography-heading();

        margin: 0;
    }

    &__description {
        .typography-body();

        margin-top: 4px;
    }

    &__buttons {
        width: 320px;
        margin: 0 auto;

        display: flex;
        align-items: center;
        gap: 4px;
    }
}
</style>
